export default __webpack_public_path__ + "static/media/lotusR.b4fae017.svg";